import { AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IModuleCustomSettingSection, ModuleCustomSettingSectionType } from 'src/shared/models/module-custom-settings-section.model';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-module-custom-setting-section',
    templateUrl: './module-custom-setting-section.component.html',
    styleUrls: ['./module-custom-setting-section.component.scss']
})
export class ModuleCustomSettingSectionComponent implements IModuleCustomSettingSection, AfterViewInit, OnDestroy {
    @Input() moduleManager: ModuleManager;
    @Input() after?: string;
    @Input() inside?: string;
    expanded = false;
    type = ModuleCustomSettingSectionType.Slideout;
    private _subscription: Subscription = null;

    constructor(private element: ElementRef<HTMLElement>) { }

    getNativeElement() {
        return this.element.nativeElement;
    }

    ngAfterViewInit() {
        this._subscription = this.moduleManager.slideoutSettingsManager.subscribe(manager => {
            manager?.placeCustomSettings(this);
        });
    }

    ngOnDestroy(): void {
        this._subscription?.unsubscribe();
    }
}
